import React, { useEffect, useState } from "react";
import "./bdmcontrols.css";

const ReviewsTable = () => {
  const [reviews, setReviews] = useState([]);
  const [config, setConfig] = useState(null);

  // Load config.json
  useEffect(() => {
    fetch("/config.json")
      .then((res) => res.json())
      .then((data) => setConfig(data))
      .catch((err) => console.error("Error loading config:", err));
  }, []);

  // Fetch reviews
  useEffect(() => {
    if (!config) return;

    fetch(`${config.BASE_URL}${config.GET_ALL_REVIEWS}`, {
      method: "POST",
      credentials: "include",
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.success) {
          setReviews(result.data);
        } else {
          alert(result.message || "Failed to fetch reviews");
        }
      })
      .catch((err) => console.error("Fetch error:", err));
  }, [config]);

 const handleAction = async (reviewId, actionType) => {
  if (!config) return;

  try {
    const res = await fetch(`${config.BASE_URL}${config.UPDATE_REVIEW_STATUS}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ review_id: reviewId, action: actionType }),
      credentials: "include",
    });
    const result = await res.json();
    if (result.success) {
      if (actionType === "accept") {
       
        setReviews((prev) => prev.filter((r) => r.review_id !== reviewId));
      } else if (actionType === "decline") {
        
        setReviews((prev) => prev.filter((r) => r.review_id !== reviewId));
      }
    } else {
      alert(result.message);
    }
  } catch (err) {
    console.error("Error updating status:", err);
  }
};



  return (
    <div className="reviews-table-container">
      <h2>Product Reviews</h2>
      <table className="reviews-table">
        <thead>
          <tr>
            <th>User</th>
            <th>Email/UserID</th>
            <th>Product</th>
            <th>Review</th>
            <th>Rating</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {reviews.length > 0 ? (
            reviews.map((r) => (
              <tr key={r.review_id}>
                <td>{r.user_name}</td>
                <td>{r.user_id}</td>
                <td>{r.product_id}</td>
                <td>{r.review}</td>
                <td>{r.rating}</td>
                <td>
  <button
    className="accept-btn"
    onClick={() => handleAction(r.review_id, "accept")}
  >
    Accept
  </button>
  <button
    className="decline-btn"
    onClick={() => handleAction(r.review_id, "decline")}
  >
    Decline
  </button>
</td>

              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7">No reviews found</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ReviewsTable;
